import { expandSizes } from "./expandSizes.mjs.mjs";
/**
 * Merges two given shorthand lists
 *
 * @template S
 * @param {S[]} shorthand List of up to four sizes defined using CSS shorthand pattern
 * @param {S[]} overrides List of up to four override sizes defined using CSS shorthand pattern
 * @returns {S[]}
 */
export function mergeSizes(shorthand = [], overrides = []) {
    const expandedShorthand = expandSizes(shorthand);
    const [blockStart = expandedShorthand[0], inlineEnd = expandedShorthand[1], blockEnd = expandedShorthand[2], inlineStart = expandedShorthand[3],] = expandSizes(overrides);
    return [blockStart, inlineEnd, blockEnd, inlineStart];
}
//# sourceMappingURL=mergeSizes.mjs.mjs.map